import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useDevice } from "@hooks/useDevice";
/* -----------------UI--------------- */
import Box from "@memorang/ui/src/components/Box";
import Button from "@memorang/ui/src/components/Button";
import DonutScore from "@memorang/ui/src/components/DonutScore";
import type { IconType } from "@memorang/ui/src/types";
import { Card, Chip, Text } from "react-native-paper";
import type { EXAM_STATUS } from "types/tag";
import { buttonConfig } from "../constants";
import { getExamStatusIcon } from "../helpers/practice-tests-data";
import CardHeaderAvatar from "./CardHeaderAvatar";
type Props = {
	label: string;
	description: string;
	text: string;
	icon: string;
	status: string;
	cta: string;
	handleNavigation: () => void;
	loading?: boolean;
	score: number;
};
export const PracticeTestListItem = ({
	label: title,
	description,
	text: label,
	icon,
	status,
	cta,
	handleNavigation,
	loading,
	score,
}: Props) => {
	const { isMobile } = useDevice();

	const Left = () => (
		<Box style={{ marginRight: 8, justifyContent: "center" }}>
			{icon ? (
				<CardHeaderAvatar icon={icon} />
			) : (
				<Box width={40} height={40} alignSelf="center">
					<DonutScore
						distribution={[score, 100 - score]}
						score={score}
						variant="progress"
						radius={20}
						innerRadius={16}
					/>
				</Box>
			)}
		</Box>
	);

	const { buttonMode, buttonIcon } = buttonConfig[status];
	const Right = () => {
		return (
			<Box justifyContent="center" paddingRight={isMobile ? 0 : 16}>
				<Button
					mode={buttonMode}
					icon={buttonIcon}
					loading={loading}
					disabled={loading}
					onPress={handleNavigation}
				>
					{cta}
				</Button>
			</Box>
		);
	};
	const examStatusIcon = getExamStatusIcon(status as unknown as EXAM_STATUS);

	const Description = () => (
		<Box style={{ gap: 8 }}>
			<Text variant="bodySmall">{description}</Text>
			<Box flexDirection="row" gap={8}>
				<Chip
					compact
					icon={(props) => (
						<Icon {...props} name={examStatusIcon as IconType} />
					)}
				>
					{label}
				</Chip>
			</Box>
		</Box>
	);

	return (
		<Box>
			<Card
				mode="elevated"
				onPress={handleNavigation}
				style={{
					overflow: "hidden",
					paddingVertical: 16,
					marginHorizontal: 16,
				}}
			>
				<Card.Title
					title={title}
					subtitleNumberOfLines={2}
					subtitle={<Description />}
					left={() => <Left />}
					right={() => !isMobile && <Right />}
				/>
				{isMobile && (
					<Card.Actions
						style={{
							paddingRight: 16,
						}}
					>
						<Button
							mode={buttonMode}
							icon={buttonIcon}
							loading={loading}
							disabled={loading}
							onPress={handleNavigation}
						>
							{cta}
						</Button>
					</Card.Actions>
				)}
			</Card>
		</Box>
	);
};
